import React, { useEffect, useCallback, useState} from 'react';
import HarmonicsEditor from './HarmonicsEditor.js';
import Notes from 'midi/Notes.js';
import FMParameter from './FMParameter.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import CheckboxParameter from 'components/effects/CheckboxParameter.js';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import Harmonicity from './Harmonicity.js';
import FMFeedback from './FMFeedback.js';
import ModulationIndex from './ModulationIndex.js';
import PartialCount from './PartialCount.js';
import WaveformDropdown from './WaveformDropdown.js';
import {connect} from 'react-redux';

const FMOperatorControl = ({selectedOscillator, instrument, color}) => { 
    let osc = instrument.getOscillator(selectedOscillator);
    return (
        <div
          className="instrument-subsection fm-operator-control" >
          <div className="top-of-section">
            <div className="instrument-subsection-name">
              {osc.name}
            </div>
            <div className="osc-type-container">
              <WaveformDropdown
                instrument={instrument}
                oscillator={osc}
                sequencerEngine={instrument.sequencerEngine}/>
            </div>
          </div>
          {osc.customOscillatorType ?
             <EffectParameterSlider
               name="Harmonics"
               sequencerEngine={instrument.sequencerEngine}
               isParameter={true}
               parameter={osc.harmonicsParameter}
               step={0.001}
               min={-1} max={1}/>
           : ''}
          {osc.oscillatorType === "custom" ? <HarmonicsEditor partials={osc.partials} oscillator={osc}/> : ""}
          {!osc.customOscillatorType && osc.oscillatorType !== "custom" ? 
           <div className="partials">
             <EffectParameterSlider
               name="Partials"
               sequencerEngine={instrument.sequencerEngine}
               isParameter={true}
               parameter={osc.partialCountParameter}
               step={1}
              min={0} max={64}/>
           </div> : ''}
          <EffectParameterSlider
            sequencerEngine={instrument.sequencerEngine}
            name={'Volume'}
            parameter={osc.oscillatorLevelParameter}
            onParameterChanged={() => []}
            displayFunction={(x) => Math.round(x * 100.0)}
            unit={'%'}
            isParameter={true}
            lfoEnabled={true}
            min={0}
            max={1}
            step={0.01}
          />
          <ConditionedComponent condition={osc.oscillatorTypeParameter.get() === 'PWM'}>
            <EffectParameterSlider
              sequencerEngine={instrument.sequencerEngine}
              name={'PWM'}
              parameter={osc.pwmParameter}
              onParameterChanged={() => []}
              isParameter={true}
              lfoEnabled={true}
              min={0}
              max={20 }
              step={0.01}
            />
          </ConditionedComponent>
          <div className="frequency-parameters">
            <EffectParameterSlider
              sequencerEngine={instrument.sequencerEngine}
              name={'Frequency'}
              parameter={
                  osc.keyboard ?
                      osc.oscillatorFrequencyParameter :
                      instrument.carrier.oscillatorFrequencyParameter}
              onParameterChanged={() => instrument.releaseAll()}
              displayFunction={(x) => Notes.fromTranspose(x).toString()}
            isParameter={true}
              min={-32}
              max={32}
              step={1}
            />
            <EffectParameterSlider
              name={'Detune'}
              sequencerEngine={instrument.sequencerEngine}
              lfoEnabled={true}
              parameter={osc.detuneParameter}
              onParameterChanged={() => []}
              isParameter={true}
              min={-100}
              max={100}
              step={1}
            />
          </div>
          {osc.bandpassParameter.get() ? 
           <div className="bandpass-parameters">
            <EffectParameterSlider
              name={'Band Freq'}
              sequencerEngine={instrument.sequencerEngine}
              lfoEnabled={true}
              parameter={osc.bandpassFrequencyParameter}
              onParameterChanged={() => []}
              isParameter={true}
              min={10}
              max={5000}
              step={1}
            />
           <EffectParameterSlider
              name={'Band Q'}
              sequencerEngine={instrument.sequencerEngine}
              lfoEnabled={true}
              parameter={osc.bandpassQParameter}
              onParameterChanged={() => []}
              isParameter={true}
              min={0.1}
              max={10}
              step={0.01}
            />
           </div> : ''}
            <ConditionedComponent condition={osc.name !== 'C'}>
              <div className="keyboard-control">
                <CheckboxParameter flipped={true} name="FM" parameter={osc.keyboardParameter}/>
                <CheckboxParameter name="Osc. Enabled" parameter={osc.enabledParameter}/>
                <CheckboxParameter name="Bandpass" parameter={osc.bandpassParameter}/>
              </div>
            </ConditionedComponent>
            <ConditionedComponent condition={osc.name === 'C'}>
              <div className="keyboard-control">
                Keyboard
              </div>
              <CheckboxParameter name="Bandpass" parameter={osc.bandpassParameter}/>
            </ConditionedComponent>
        </div>);
}

const mapStateToProps = (state, props) => {
    let osc = props.instrument.getOscillator(props.selectedOscillator);
    return {
        keyboard: osc.keyboard,
        customOscillatorType: osc.customOscillatorType,
        oscillatorType: osc.oscillatorType,
        partials: osc.partials,
        bandpass: osc.bandpassParameter.get(),
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FMOperatorControl);
